import "./opener.styles.scss"
import Icon from "../icon/icon.component"
import tech_nation from "../../assets/homepage/tech_nation.png"
import bd from "../../assets/homepage/bd.png"
import dci from "../../assets/homepage/DCI.png"
import landing from "../../assets/tutoring/landing.png"
import solana_logo from "../../assets/homepage/solana-sol-logo.png"
import Typewriter from "typewriter-effect"
import CountUp from "react-countup"

function Opener(props) {
  return (
    <div className="opener-wrapper">
      <div className="opener-main">
        <div className="titles">
          <h1 className="header">
            The future of learning is <br />
            <Typewriter
              className="typewriter"
              options={{
                strings: ["Free", "Targeted", "On demand", "Built on EdEq"],
                autoStart: true,
                loop: true,
              }}
            />
          </h1>
          <div className="sub-header">
            <img src={solana_logo} alt="Solana logo" className="sol-logo" />
            <h2>Coming Q2 2022</h2>
          </div>
          <div className="button-holder">
            {/* <a href="https://twitter.com/EdEq22" target="_blank">
              Be the first to know
            </a> */}
            <a href="https://platform.educationequation.co.uk" target="_blank">
              Try our alpha
            </a>
          </div>
        </div>
        <div className="image">
          {props.tutoring ? <img src={landing} /> : <Icon name="my_progress" />}
        </div>
      </div>
      <div className="opener-images">
        <div>
          <div className="statistic">
            <h3>Alpha users</h3>
            <h4>
              <CountUp start={1} end={1050} suffix={"+"} duration={2} />
            </h4>
          </div>
        </div>
        <div>
          <div className="statistic">
            <h3>Courses by '22</h3>
            <h4>
              <CountUp start={1} end={150} suffix={"+"} duration={2} />
            </h4>
          </div>
        </div>
        <div>
          <div className="statistic">
            <h3>Influencer audience</h3>
            <h4>1M+</h4>
          </div>
        </div>
      </div>
      <hr />
    </div>
  )
}

export default Opener
